import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHierarchyRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.5 4.5h1v1h-1zM9 3a1 1 0 0 0-1 1v2q0 1 1 1h.3v2H5.5q-2 .2-2.2 2.3V13H3a1 1 0 0 0-1 1v2q0 1 1 1h2q1 0 1-1v-2q0-1-1-1h-.2v-1.7q0-.8.7-.8h3.8V13H9a1 1 0 0 0-1 1v2q0 1 1 1h2q1 0 1-1v-2q0-1-1-1h-.2v-2.5h3.7q.7 0 .8.8V13H15a1 1 0 0 0-1 1v2q0 1 1 1h2q1 0 1-1v-2q0-1-1-1h-.2v-1.7q-.2-2.1-2.3-2.3h-3.7V7h.2q1 0 1-1V4q0-1-1-1zM3.5 15.5v-1h1v1zm6 0v-1h1v1zm6 0v-1h1v1z" })
});
export default SvgHierarchyRegularIcon;
